import store from "@/store";
const directorAuth = (to, from, next) => {
  if (!store.getters.isDirectorAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/director/loginDo");
  } else {
    next();
  }
};
const funeralAuth = (to, from, next) => {
  if (!store.getters.isFuneralAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/funeral/loginDo");
  } else {
    next();
  }
};

const corpAuth = (to, from, next) => {
  if (!store.getters.isCorpAuthenticated) {
    // 아직 로그인이 안 되있는 유저니까 막아야 한다.
    alert("로그인이 필요합니다");
    next("/corp/loginDo");
  } else {
    next();
  }
};

export default [
  {
    meta: {
      title: "PayBack"
    },
    path: "/director/payback",
    name: "PayBack",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/payback/PayBack.vue")
  },
  {
    meta: {
      title: "PayBackDetail"
    },
    path: "/director/payback-detail",
    name: "PayBackDetail",
    beforeEnter: directorAuth,
    component: () => import("@/views/director/payback/PayBackDetail.vue")
  },
  {
    meta: {
      title: "PayBack"
    },
    path: "/funeral/payback",
    name: "PayBack",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/payback/PayBack.vue")
  },
  {
    meta: {
      title: "PayBackDetail"
    },
    path: "/funeral/payback-detail",
    name: "PayBackDetail",
    beforeEnter: funeralAuth,
    component: () => import("@/views/funeral/payback/PayBackDetail.vue")
  },
  {
    meta: {
      title: "PayBack"
    },
    path: "/corp/payback",
    name: "PayBack",
    beforeEnter: corpAuth,
    component: () => import("@/views/corp/payback/PayBack.vue")
  },
  {
    meta: {
      title: "PayBackDetail"
    },
    path: "/corp/payback-detail",
    name: "PayBackDetail",
    beforeEnter: corpAuth,
    component: () => import("@/views/corp/payback/PayBackDetail.vue")
  }
];
